var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "md-app",
        { attrs: { "md-mode": "fixed" } },
        [
          _c(
            "md-app-toolbar",
            [
              _vm.isLoggedIn
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button mobile__menu-icon",
                      on: {
                        click: function($event) {
                          _vm.menuVisible = !_vm.menuVisible
                        }
                      }
                    },
                    [_c("md-icon", [_vm._v("menu")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("navbar")
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c(
                "md-app-drawer",
                {
                  staticClass: "scrollbar",
                  attrs: {
                    "md-permanent": "clipped",
                    "md-active": _vm.menuVisible
                  },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.menuVisible = $event
                    },
                    "update:md-active": function($event) {
                      _vm.menuVisible = $event
                    }
                  }
                },
                [
                  _c("sidebar", {
                    on: {
                      "hide-sidebar": _vm.hideSidebar,
                      "show-popup": _vm.openPopup,
                      "close-popup": _vm.closePopup
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-app-content",
            [
              _c("router-view"),
              _vm._v(" "),
              _c("snackbar"),
              _vm._v(" "),
              _c("file-viewer"),
              _vm._v(" "),
              _c("loader-bar")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a7a1796", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a7a1796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/root/App.vue
// module id = joay
// module chunks = 1